import { render } from "./ButtonOrange.vue?vue&type=template&id=418e0a8c&scoped=true"
import script from "./ButtonOrange.vue?vue&type=script&lang=js"
export * from "./ButtonOrange.vue?vue&type=script&lang=js"

import "./ButtonOrange.vue?vue&type=style&index=0&id=418e0a8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418e0a8c"]])

export default __exports__